<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 1000px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ $t('attributes.modify') + $t('attributes.schedule') }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <div class="columns">
              <div class="column">
                <b-field
                  :label-position="labelPosition"
                  :label="$t('attributes.day')"
                >
                  <b-input
                    v-model="form.day"
                    type="number"
                    min="1"
                    :max="schedule.days"
                    expanded
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field
                  :label-position="labelPosition"
                  :label="$t('attributes.total_days')"
                >
                  <b-input v-model="days" disabled expanded></b-input>
                </b-field>
              </div>
            </div>

            <form-group
              name="name"
              :label="$t('attributes.name')"
              :label-position="labelPosition"
            >
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              name="breakfast_desc"
              :label="$t('attributes.breakfast_desc')"
              :label-position="labelPosition"
            >
              <b-input
                v-model="form.breakfast_desc"
                name="breakfast_desc"
                :placeholder="
                  $t('message.please_input') + $t('attributes.breakfast_desc')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              name="launch_desc"
              :label="$t('attributes.launch_desc')"
              :label-position="labelPosition"
            >
              <b-input
                v-model="form.launch_desc"
                name="launch_desc"
                :placeholder="
                  $t('message.please_input') + $t('attributes.launch_desc')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              name="dinner_desc"
              :label="$t('attributes.dinner_desc')"
              :label-position="labelPosition"
            >
              <b-input
                v-model="form.dinner_desc"
                name="dinner_desc"
                :placeholder="
                  $t('message.please_input') + $t('attributes.dinner_desc')
                "
                expanded
              >
              </b-input>
            </form-group>

            <div class="columns is-multiline">
              <div class="column is-6">
                <form-group
                  name="hotel_sort"
                  :label="$t('attributes.hotel_sort')"
                  :label-position="labelPosition"
                  expanded
                >
                  <b-select
                    v-model="form.hotel_sort"
                    name="hotel_sort"
                    expanded
                  >
                    <option
                      v-for="option in hotelSortType"
                      :key="option"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </b-select>
                </form-group>
              </div>

              <div class="column is-6">
                <form-group
                  name="show_same"
                  :label="$t('attributes.show_same')"
                  :label-position="labelPosition"
                  expanded
                >
                  <b-select v-model="form.show_same" name="show_same" expanded>
                    <option value="Y">是</option>
                    <option value="N">否</option>
                  </b-select>
                </form-group>
              </div>

              <div class="column is-6">
                <form-group
                  name="hotel_no1"
                  :label="$t('attributes.stay_hotel') + '1'"
                  :label-position="labelPosition"
                >
                  <b-autocomplete
                    v-model="selectedHotel1"
                    name="hotel_no1"
                    field="name"
                    :data="paginateHotels"
                    :placeholder="
                      $t('message.please_input') + $t('attributes.hotel')
                    "
                    :open-on-focus="true"
                    :keep-first="true"
                    :loading="loadingHotels"
                    :check-infinite-scroll="true"
                    @focus="onSelectHotel"
                    @typing="onSelectingHotel"
                    @select="onSelectedHotel1"
                    @infinite-scroll="moreHotels"
                  >
                    <template #default="props">
                      <div class="media">
                        <div class="media-left" :style="hotelOptionStyle">
                          {{ props.option.id }}
                        </div>
                        <div class="media-content">
                          {{ props.option.name }}
                        </div>
                      </div>
                    </template>
                    <template #empty>
                      No results found
                    </template>
                  </b-autocomplete>
                </form-group>
              </div>

              <div class="column is-6">
                <form-group
                  name="hotel_no2"
                  :label="$t('attributes.stay_hotel') + '2'"
                  :label-position="labelPosition"
                >
                  <b-autocomplete
                    v-model="selectedHotel2"
                    name="hotel_no2"
                    field="name"
                    :data="paginateHotels"
                    :placeholder="
                      $t('message.please_input') + $t('attributes.hotel')
                    "
                    :open-on-focus="true"
                    :keep-first="true"
                    :loading="loadingHotels"
                    :check-infinite-scroll="true"
                    @focus="onSelectHotel"
                    @typing="onSelectingHotel"
                    @select="onSelectedHotel2"
                    @infinite-scroll="moreHotels"
                  >
                    <template #default="props">
                      <div class="media">
                        <div class="media-left" :style="hotelOptionStyle">
                          {{ props.option.id }}
                        </div>
                        <div class="media-content">
                          {{ props.option.name }}
                        </div>
                      </div>
                    </template>
                    <template #empty>
                      No results found
                    </template>
                  </b-autocomplete>
                </form-group>
              </div>

              <div class="column is-6">
                <form-group
                  name="hotel_no3"
                  :label="$t('attributes.stay_hotel') + '3'"
                  :label-position="labelPosition"
                >
                  <b-autocomplete
                    v-model="selectedHotel3"
                    name="hotel_no3"
                    field="name"
                    :data="paginateHotels"
                    :placeholder="
                      $t('message.please_input') + $t('attributes.hotel')
                    "
                    :open-on-focus="true"
                    :keep-first="true"
                    :loading="loadingHotels"
                    :check-infinite-scroll="true"
                    @focus="onSelectHotel"
                    @typing="onSelectingHotel"
                    @select="onSelectedHotel3"
                    @infinite-scroll="moreHotels"
                  >
                    <template #default="props">
                      <div class="media">
                        <div class="media-left" :style="hotelOptionStyle">
                          {{ props.option.id }}
                        </div>
                        <div class="media-content">
                          {{ props.option.name }}
                        </div>
                      </div>
                    </template>
                    <template #empty>
                      No results found
                    </template>
                  </b-autocomplete>
                </form-group>
              </div>

              <div class="column is-6">
                <form-group
                  name="hotel_no4"
                  :label="$t('attributes.stay_hotel') + '4'"
                  :label-position="labelPosition"
                >
                  <b-autocomplete
                    v-model="selectedHotel4"
                    name="hotel_no4"
                    field="name"
                    :data="paginateHotels"
                    :placeholder="
                      $t('message.please_input') + $t('attributes.hotel')
                    "
                    :open-on-focus="true"
                    :keep-first="true"
                    :loading="loadingHotels"
                    :check-infinite-scroll="true"
                    @focus="onSelectHotel"
                    @typing="onSelectingHotel"
                    @select="onSelectedHotel4"
                    @infinite-scroll="moreHotels"
                  >
                    <template #default="props">
                      <div class="media">
                        <div class="media-left" :style="hotelOptionStyle">
                          {{ props.option.id }}
                        </div>
                        <div class="media-content">
                          {{ props.option.name }}
                        </div>
                      </div>
                    </template>
                    <template #empty>
                      No results found
                    </template>
                  </b-autocomplete>
                </form-group>
              </div>

              <div class="column is-6">
                <form-group
                  name="hotel_no5"
                  :label="$t('attributes.stay_hotel') + '5'"
                  :label-position="labelPosition"
                >
                  <b-autocomplete
                    v-model="selectedHotel5"
                    name="hotel_no5"
                    field="name"
                    :data="paginateHotels"
                    :placeholder="
                      $t('message.please_input') + $t('attributes.hotel')
                    "
                    :open-on-focus="true"
                    :keep-first="true"
                    :loading="loadingHotels"
                    :check-infinite-scroll="true"
                    @focus="onSelectHotel"
                    @typing="onSelectingHotel"
                    @select="onSelectedHotel5"
                    @infinite-scroll="moreHotels"
                  >
                    <template #default="props">
                      <div class="media">
                        <div class="media-left" :style="hotelOptionStyle">
                          {{ props.option.id }}
                        </div>
                        <div class="media-content">
                          {{ props.option.name }}
                        </div>
                      </div>
                    </template>
                    <template #empty>
                      No results found
                    </template>
                  </b-autocomplete>
                </form-group>
              </div>
            </div>

            <form-group name="brief_desc" attribute="attributes.schedule_brief">
              <b-field :label="$t('attributes.schedule_brief')">
                <div class="content">
                  <editor
                    ref="brief_desc_editor"
                    v-model="form.brief_desc"
                    :area="area"
                  ></editor>
                </div>
              </b-field>
            </form-group>

            <form-group
              name="detail_topic"
              attribute="attributes.schedule_detail_topic"
            >
              <b-field>
                <template #label>
                  <p class="has-text-danger">
                    {{ $t('attributes.schedule_detail_topic') }}
                  </p>
                </template>
                <div class="content">
                  <editor
                    ref="detail_topic_editor"
                    v-model="form.detail_topic"
                    :area="area"
                  ></editor>
                </div>
              </b-field>
            </form-group>

            <form-group
              name="detail_desc"
              attribute="attributes.schedule_detail_desc"
            >
              <b-field>
                <template #label>
                  <p class="has-text-danger">
                    {{ $t('attributes.schedule_detail_desc') }}
                  </p>
                </template>
                <div class="content">
                  <editor
                    ref="detail_desc_editor"
                    v-model="form.detail_desc"
                    :area="area"
                  ></editor>
                </div>
              </b-field>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            disabled="disabled"
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ $t('attributes.update') }}
          </b-button>
        </footer>

        <b-loading
          :active="isLoading"
          :is-full-page="false"
          :can-cancel="false"
        />
      </div>
    </form>
  </section>
</template>

<script>
import { debounce } from 'lodash'
import {
  required,
  maxLength,
  minValue,
  maxValue
} from 'vuelidate/lib/validators'
import { HOTELS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'ScheduleForm',
  components: { Editor },

  props: {
    schedule: {
      type: Object,
      required: true
    },
    area: {
      type: String,
      required: true
    },
    sending: {
      type: Boolean
    }
  },
  data() {
    return {
      days: this.schedule.days,
      form: this.extractFormValues(this.schedule),

      loadingHotels: false,
      search: '',
      hotels: [],
      filterHotels: [],
      paginateHotels: [],
      page: 1,
      total_page: 1,
      page_size: 10,
      hotelOptionStyle: {
        width: '100px'
      },

      selectedHotel1: null,
      selectedHotel2: null,
      selectedHotel3: null,
      selectedHotel4: null,
      selectedHotel5: null,
      hotelSortType: ['一般', 'A~Z'],

      labelPosition: 'on-border'
    }
  },
  validations() {
    return {
      form: {
        day: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(this.schedule.days)
        },
        name: { required, maxLength: maxLength(3000) },
        brief_desc: {},
        detail_topic: { maxLength: maxLength(500) },
        detail_desc: {},
        breakfast_desc: { maxLength: maxLength(150) },
        launch_desc: { maxLength: maxLength(150) },
        dinner_desc: { maxLength: maxLength(150) },
        hotel_sort: { maxLength: maxLength(50) },
        hotel_no1: { maxLength: maxLength(20) },
        hotel_no2: { maxLength: maxLength(20) },
        hotel_no3: { maxLength: maxLength(20) },
        hotel_no4: { maxLength: maxLength(20) },
        hotel_no5: { maxLength: maxLength(20) },
        show_same: { maxLength: maxLength(5) }
      }
    }
  },
  computed: {
    isLoading() {
      return this.loadingHotels || this.sending
    }
  },
  mounted() {
    this.getHotels()
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        day: data.day,
        name: data.name,
        brief_desc: data.brief_desc,
        detail_topic: data.detail_topic,
        detail_desc: data.detail_desc,
        breakfast_desc: data.breakfast_desc,
        launch_desc: data.launch_desc,
        dinner_desc: data.dinner_desc,
        hotel_sort: data.hotel_sort || '一般',
        hotel_no1: data.hotel_no1,
        hotel_no2: data.hotel_no2,
        hotel_no3: data.hotel_no3,
        hotel_no4: data.hotel_no4,
        hotel_no5: data.hotel_no5,
        show_same: data.show_same ? data.show_same.trim() : 'Y'
      }
    },
    async getHotels() {
      try {
        const api = `${HOTELS_API}/list`
        const params = { search: null }

        this.loadingHotels = true
        const res = await this.axios.get(api, { params })
        this.hotels = res.data.data
        this.paginateHotels = this.hotels.slice()
        this.filterHotels = []
        this.total_page = Math.ceil(this.paginateHotels.length / this.page_size)

        this.initSelectedHotels()
      } catch (e) {
        this.hotels = []
        this.paginateHotels = []
        this.filterHotels = []
        this.total_page = 1

        notifyService.fetch_error('hotel', e)
      } finally {
        this.loadingHotels = false
      }
    },
    initSelectedHotels() {
      if (!this.selectedHotel1) {
        const hotel = this.hotels.find(h => h.id === this.form.hotel_no1)
        this.selectedHotel1 = hotel && hotel.name
      }
      if (!this.selectedHotel2) {
        const hotel = this.hotels.find(h => h.id === this.form.hotel_no2)
        this.selectedHotel2 = hotel && hotel.name
      }
      if (!this.selectedHotel3) {
        const hotel = this.hotels.find(h => h.id === this.form.hotel_no3)
        this.selectedHotel3 = hotel && hotel.name
      }
      if (!this.selectedHotel4) {
        const hotel = this.hotels.find(h => h.id === this.form.hotel_no4)
        this.selectedHotel4 = hotel && hotel.name
      }
      if (!this.selectedHotel5) {
        const hotel = this.hotels.find(h => h.id === this.form.hotel_no5)
        this.selectedHotel5 = hotel && hotel.name
      }
    },
    onSelectHotel() {
      this.search = null
      this.filteringHotels()
    },
    onSelectingHotel: debounce(function(search) {
      if (this.search === search) {
        return
      }

      this.search = search
      this.filteringHotels()
    }, 500),
    filteringHotels() {
      if (!this.search) {
        this.filterHotels = this.hotels.slice()
      } else {
        const key = this.search.toUpperCase()
        this.filterHotels = this.hotels.filter(hotel => {
          return (
            hotel.id.toUpperCase().startsWith(key) ||
            hotel.name.toUpperCase().includes(key)
          )
        })
      }

      this.page = 1
      this.total_page = Math.ceil(this.filterHotels.length / this.page_size)
      this.paginateHotels = this.filterHotels.slice(0, this.page_size)
    },
    moreHotels() {
      if (this.page > this.total_page) {
        return
      }

      const hotels = this.filterHotels.slice(
        this.page * this.page_size,
        (this.page + 1) * this.page_size
      )
      this.page++
      this.paginateHotels.push(...hotels)
    },
    onSelectedHotel1(option) {
      this.form.hotel_no1 = option && option.id
    },
    onSelectedHotel2(option) {
      this.form.hotel_no2 = option && option.id
    },
    onSelectedHotel3(option) {
      this.form.hotel_no3 = option && option.id
    },
    onSelectedHotel4(option) {
      this.form.hotel_no4 = option && option.id
    },
    onSelectedHotel5(option) {
      this.form.hotel_no5 = option && option.id
    },
    async onSend() {
      this.form.brief_desc = this.$refs.brief_desc_editor.getData()
      this.form.detail_topic = this.$refs.detail_topic_editor.getData()
      this.form.detail_desc = this.$refs.detail_desc_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
